document.addEventListener("click", function (e) {
  if (e.target.closest(".wof-add-to-cart-button")) {
    setTimeout(function () {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          let cartCount = cart.item_count;
          let cartIcon = document.getElementById("cart-icon-bubble");
          let bubble = cartIcon.querySelector(".cart-count-bubble");

          if (cartCount === 1 && !bubble) {
            // Append new bubble if not exists
            cartIcon.insertAdjacentHTML(
              "beforeend",
              `<div class="cart-count-bubble">
                 <span aria-hidden="true">${cartCount}</span>
                 <span class="visually-hidden">${cartCount} item</span>
               </div>`
            );
          } else if (bubble) {
            // Update existing bubble count
            let spans = bubble.querySelectorAll("span");
            if (spans.length > 0) spans[0].textContent = cartCount;
            if (spans.length > 1)
              spans[1].textContent =
                cartCount === 1 ? `${cartCount} item` : `${cartCount} items`;
          }
        });
    }, 1000);
  }
});